import React, { FunctionComponent } from 'react';
import { Dropdown } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../helpers/html.utils';
import { ILabel } from '../../../models/common/label.model';
import { IPDPPPK } from '../../../models/pdp/pdp-ppk.model';
import styles from './ppk-component.module.scss';

type PPKProps = {
  labels?: ILabel[] | null;
  ppkArea: IPDPPPK;
  standardSsm: number;
  stockCode?: string;
  isInFixedCTA?: boolean;
  openDropdownCallback?: (isOpen: boolean) => void;
  selectCallback: (stockCode: string) => void;
};

export const PPK: FunctionComponent<PPKProps> = (props: PPKProps) => {
  return (
    <div className={`${styles['ppk-container']} ${props.isInFixedCTA ? styles['ppk-fixed-cta'] : ''}`}>
      <span>{getLabel(props.labels, 'select_packaging_type')}</span>

      <Dropdown
        className={styles['ppk-dropdown']}
        placeholder={getLabel(props.labels, 'select_packaging_type')}
        defaultSelection={props.stockCode}
        showSeparatorBetweenElements={true}
        onChangeState={(isOpen) => {
          props.openDropdownCallback && props.openDropdownCallback(isOpen);
        }}
        selectCallback={(key) => {
          props.selectCallback && props.selectCallback(key.toString());
        }}
        list={[
          {
            key: props.ppkArea.standardStockCode,
            displayString: getLabel(props.labels, 'ppk_standard'),
            elt: (
              <div className={styles['ppk-type']}>
                <p>
                  {getLabel(props.labels, 'ppk_standard')} -&nbsp;
                  {props.ppkArea.standardUnitOfMeasure && props.ppkArea.standardUnitOfMeasure.toLowerCase()}
                </p>
                <p className={styles.description}>
                  {getLabel(props.labels, 'available_in_multiples')} {props.standardSsm}.
                </p>
              </div>
            ),
          },
          {
            key: props.ppkArea.ppkStockCode,
            displayString: props.ppkArea.title ?? getLabel(props.labels, 'ppk_production'),
            elt: (
              <div className={styles['ppk-type']}>
                <p>
                  {getLabel(props.labels, 'ppk_production')} - {props.ppkArea.unitOfMeasure && props.ppkArea.unitOfMeasure.toLowerCase()}
                </p>
                <div className={styles.description}>
                  <p>
                    {getLabel(props.labels, 'available_in_multiples')} {props.ppkArea.ppkSSM}.
                  </p>
                  <p>{getLabel(props.labels, 'production_pack_description')}</p>
                </div>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default PPK;
